module.exports = __webpack_public_path__ + "img/ic_policy_cert.d0289dc0.png";